module.exports = __webpack_public_path__ + "static/feynman-4f5a46004ef3ed8cf2144ffc72997ee9.png";